/* TODO: spojiť s multiple selectom ... */

$(document).on('mouseenter', '.js-search-select:not(.initialized)', function(){

    if($(this).hasClass('initialized')){
        return;
    }

    $(this).addClass('initialized');
    $(this).focusout();

    let options = $(this).find('option');
    let placeholder = false;
    let dropdown_content = '';

    // Vytvoriť dropdown obsahujúci všetky možnosti
    options.each(function(index){
        if(index){
            dropdown_content += `<div data-index="`+ index +`">${$(this).text().trim()}</div>`;
        }else{
            if($(this).attr('value') === '' || $(this).attr('value') == 0) {
                placeholder = $(this).text().trim();
            }
        }
    });

    let search_select_append = `
        <div class="search-select">
            <input placeholder="`+ placeholder +`" class="form-control js-search-select-input" type="text">
            <div class="dropdown form-control">
                ${dropdown_content}
            </div>
        </div>`;
    $(this).after(search_select_append);
});

$(document).on('click', '.search-select .dropdown div', function(){

    let value = $(this).text();
    let dropdown = $(this).parents('.dropdown');
    $('.selected', dropdown).removeClass('selected');
    $(this).addClass('selected');
    let search_select = $(this).closest('.search-select');
    let input = search_select.find('input');
    search_select.removeClass('dropdown-active');
    input.hide(); // Skryť input po výbere položky
    //dropdown.hide(); // Skryť dropdown po výbere položky - netreba spraví to focus out funkcia

    if($('.selected-value', search_select).length === 0){
        search_select.append(`<div class="selected-value form-control">${value}</div>`); // Pridať vybranú hodnotu ako div
    }

    // Získať index vybranej možnosti
    let index = $(this).data('index');

    // Nastaviť vybranú možnosť v pôvodnom selecte
    let original_select = search_select.prev('.js-search-select');
    original_select.find('option').eq(index).prop('selected', true).change();

});

// Fulltextové vyhľadávanie
$(document).on('input', '.js-search-select-input', function() {

    let searchTerm = $(this).val().toLowerCase();
    let search_select = $(this).closest('.search-select');
    let select_input = search_select.prev('.js-search-select.initialized');
    let dropdown = search_select.find('.dropdown');
    $('.selected', dropdown).removeClass('selected');

    select_input.val(''); // Vymazať obsah inputu, ak nie je vybraná žiadna možnosť

    let one_visible = false;

    $('div', dropdown).each(function() {
        let text = $(this).text().toLowerCase();
        if (text.indexOf(searchTerm) > -1) {
            $(this).show();
            one_visible = true;
            $('.nothing-found', dropdown).remove();
        } else {
            $(this).hide();
        }
    });

    if(!one_visible){
        dropdown.append('<div class="nothing-found">---</div>');
    }
});

$(document).on('focus', '.js-search-select-input', function(event) {
    // open dropdown
    let search_select = $(this).closest('.search-select');
    search_select.addClass('dropdown-active');
});

$(document).on('click', '.search-select .selected-value', function(){
    let search_select = $(this).closest('.search-select');
    search_select.addClass('dropdown-active');
    let selected_value = $(this).text();
    $(this).remove();
    search_select.find('.js-search-select-input').show().val(selected_value).focus(); // Zobraziť input a aktivovať ho
    let dropdown = search_select.find('.dropdown');
    $('div', dropdown).show();
    dropdown.show();
});

$(document).on('focusout', '.js-search-select-input', function(event) {

    let search_select = $(this).closest('.search-select');

    /* fire click on dropdown item event first */
    setTimeout(function () {
        if (!$('.dropdown .selected', search_select).length) {
            // Vymazať obsah inputu, ak nie je vybraná žiadna možnosť
            $('input', search_select).val('');
            /* zobraziť všetky možnosti */
            let dropdown = search_select.find('.dropdown');
            $('.nothing-found', dropdown).remove();
            $('div', dropdown).show();
        }
        search_select.removeClass('dropdown-active');
    }, 250);
});
